/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductCarousel_item = {
    readonly serviceId: string | null;
    readonly carouselPhotos: ReadonlyArray<{
        readonly __typename: string;
    } | null> | null;
    readonly viewInRoomPhotos: ReadonlyArray<{
        readonly __typename: string;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_item">;
    readonly " $refType": "ProductCarousel_item";
};
export type ProductCarousel_item$data = ProductCarousel_item;
export type ProductCarousel_item$key = {
    readonly " $data"?: ProductCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductCarousel_item">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 2,
      "kind": "LocalArgument",
      "name": "photosLimit"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "viewInRoomLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductCarousel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "carouselPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "viewInRoomLimit"
        }
      ],
      "concreteType": "viewInRoomPhotos",
      "kind": "LinkedField",
      "name": "viewInRoomPhotos",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "photosLimit",
          "variableName": "photosLimit"
        },
        {
          "kind": "Variable",
          "name": "viewInRoomLimit",
          "variableName": "viewInRoomLimit"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductSwiper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = 'f147bac1cebcb5d99a17053cb1f270ec';
export default node;
